export default "__VITE_ASSET__Tu$h_avZ__"